<template>
    <div class="KM-analysis">
        <div class="analysis-top">
            <el-button type="primary" size="small" :loading="downloading" @click="savePic">保存图片</el-button>
            <div class="pic-tip">*图片可点击放大</div>
        </div>
        <div class="analysis-pic">
            <div v-if="analysis_url==''" slot="error" class="load-img">
                <!-- <i class="el-icon-picture-outline"></i> -->
                图片加载中～
            </div>
            <el-image 
                v-else
                width="100%"
                :src="analysis_url" 
                ref="picurl"
                :preview-src-list="analysis_srcList">
            </el-image>
        </div>
    </div>
</template>

<script>

import { mapState,mapMutations } from 'vuex';
import {kmeansCu} from '../../../io/api.js'
import saveImg from '../../../utils/saveImg.js'
export default {
    // props:['url','srcList','show'],
    data () {
        return {
            downloading:false,
            labelWidth:'60px',
            
            kValue:'',
            show_nodeName:0,
        }
    },
    computed: {
        ...mapState({
            analysis_url:state=>state.excavate.analysis_url,
            analysis_srcList:state=>state.excavate.analysis_srcList
        })
    },
    methods: {
        savePic(){
            saveImg(this.$refs.picurl.src,new Date().getTime() )
            
        },
    }
}
</script>

<style>

</style>